"use client";
import { useAnalytics } from "@areahub/adapters";
import colors from "@areahub/theme/src/foundations/colors";
import { Flex, Heading } from "@chakra-ui/react";
import { Button, Button_T } from "@ui/components/button";
import { SectionTemplate } from "components/individuals/blocks";
import { usePathname } from "next/navigation";

export interface IndustriesCTASectionProps {
  title: string;
  titleColor: string;
  bg: string;
  /**
   * CTA buttons
   */
  buttons: Button_T[];
}

export const IndustriesCTASection = (props: IndustriesCTASectionProps) => {
  const analytics = useAnalytics();
  const pathname = usePathname();
  const slug = pathname?.split("/")[2];
  return (
    <SectionTemplate bg={props.bg}>
      <Flex
        flexDir={"column"}
        justify={"center"}
        align={"center"}
        gap={{
          base: 5,
          lg: 10,
        }}
        h={{
          base: "150px",
          lg: "300px",
        }}
      >
        <Heading
          color={props.titleColor}
          as={"h2"}
          fontWeight={"bold"}
          fontSize={{
            base: 26,
            md: 34,
            lg: 38,
            xl: 45,
          }}
          lineHeight={1.2}
          textAlign={"center"}
        >
          {props.title}
        </Heading>
        <Button
          bgColor={colors.enterpriseColors.blue["200"]}
          color={"white"}
          fontSize={{
            base: 12,
            md: 14,
            lg: 16,
            xl: 18,
          }}
          fontWeight={"bold"}
          py={{
            base: 4,
            lg: 7,
            xl: 8,
          }}
          w={{
            base: "140px",
            md: "160px",
            lg: "180px",
            xl: "220px",
          }}
          onClick={() =>
            analytics.track(
              `User clicked 'Request a Demo' button on ${slug} landing page`,
              {
                ui: "IndustriesCTASection",
              },
            )
          }
          textTransform={"uppercase"}
          {...props.buttons?.[0]}
        />
      </Flex>
    </SectionTemplate>
  );
};
